module.exports = __webpack_public_path__ + "static/media/TrybeStore.ccb331dc.PNG";